"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m22.9 10.69-1.44-4.32C21.18 5.55 20.42 5 19.56 5H19V4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-2c-1.1 0-2 .9-2 2v4H1v5c0 1.1.9 2 2 2h1c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h3v-6.68c0-.21-.03-.42-.1-.63M14 7h5.56l1.33 4H14zM7 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m5-3H9.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3v-3h9zm5 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m2.22-3c-.55-.61-1.34-1-2.22-1s-1.67.39-2.22 1H14v-3h7v3z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M11 8.5h-1v-2h1V5H1v1.5h1v2H1V10h10zm-2.5 0H6.75v-2H8.5zm-5-2h1.75v2H3.5z"
}, "1")], 'FireTruckOutlined');